module.exports = function dynamicContentProduct(template, itemType) {
    return function () {
        return {
            restrict: 'E',
            require: '^olyDynamicContent',
            scope: {
                itemId: '@',
                forceSmallFormatView: '=?',
                smallFormatStampSize: '=?'
            },
            link(scope, element, attrs, dcCtrl) {
                dcCtrl.getServerItem(parseInt(scope.itemId), itemType)
                    .then(function (item) {
                        scope.item = item;
                    });
            },
            template
        };
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/dynamiccontent/dynamic-content-item-directive.js
 **/